<template>
  <router-view/>
</template>

<script>
  import RouteEntryMixin from '@com/mixins/route-entry'

  export default {
    name: 'verification',
    mixins: [RouteEntryMixin],
    data: _ => ({
      routes: [
        { path: '/verification/make', label: 'Verification' }
      ]
    })
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/verification/Verification.Entry.vue